export const ACCOUNT_LIST_CONSTANT = {
  PLACEHOLDER_SEARCH: 'Search By Name and Phone Number',

  TABLE_DATETIME_COLUMN: 'Date & Time',
  TABLE_FIRSTNAME_COLUMN: 'First Name',
  TABLE_LASTNAME_COLUMN: 'Last Name',
  TALBE_PHONENUMBER_COLUMN: 'Phone Number',
  TABLE_STATUS_COLUMN: 'Status',
  TABLE_ACTION_COLUMN: 'Action',

  NOTIFICATION_ERROR_TITLE: 'Error!',
  NOTIFICATION_ERROR_CONTENT_GET_USERACCOUNTLIST: 'Failed Get List',
  NOTIFICATION_ERROR_CONTENT_DETAIL_GET_USERACCOUNTLIST: 'Get User Account List Failed',

  MODAL_TITLE_UNBANNED_ACCOUNT: 'Unbanned Account Data?',
  MODAL_CONTENT_UNBANNED_ACCOUNT: 'This data will be Unbanned Account from your list',
  MODAL_OK_BUTTON_UNBANNED_ACCOUNT: 'Yes, Unbanned Account',
  MODAL_CANCEL_BUTTON_UNBANNED_ACCOUNT: 'Cancel',

  MODAL_DETAIL_TITLE_ACCOUNT: 'Detail User Account List',
  MODAL_DETAIL_TITLE_UNBANNED_ACCOUNT: 'Unbanned User Account List',

  MODAL_SUCCESS_TITLE_UNBANNED_ACCOUNT: 'Success',
  MODAL_SUCCESS_CONTENT_UNBANNED_ACCOUNT: 'The account has been unbanned',
  MODAL_SUCCESS_OK_BUTTON_UNBANNED_ACCOUNT: "Back to Account List",

  MODAL_FAILED_TITLE_UNBANNED_ACCOUNT: 'Failed',
  MODAL_FAILED_CONTENT_UNBANNED_ACCOUNT: 'The account unbanned failed',
  MODAL_FAILED_OK_BUTTON_UNBANNED_ACCOUNT: "Back to Account List",

  MENU_USER_ACCOUNT_LIST: 'User Account List',
  MENU_UNBANNED_USER_ACCOUNT_LIST: 'Unbanned User Account List',
  TITLE_FORM_DETAIL_USER_ACCOUNT_LIST: 'Detail User Account List',
}